import React, { Component } from 'react';
import { connect } from 'react-redux';
import { updateModule, updatePage, addPageToBreadCrumbs } from 'actions/siteTracking';
import { updatePermissions } from 'actions/permissions';
import { setHomeTour } from 'actions/tour';

import { updateUsers } from 'actions/company';
import { MENU as COLO_MENU } from 'utils/ColoConstants';
import { SITE_PAGES, SITE_MODULES } from 'utils/CommonConstants';
import { Utils } from 'services/utils';
import { Permissions } from 'services/permissions';

import Example from './Example';

class PowerPage extends Component {
	constructor(props) {
		super(props);

		this.state = {
			role: null,
			show: 'block',
		};
	}

	componentWillUnmount() {
		Utils.removeHorizontalBar();
	}

	componentDidMount() {
		const { updateModule, updatePage, addPageToBreadCrumbs, site, permissions } = this.props;

		updatePage(SITE_PAGES.COLO[COLO_MENU.POWER]);
		addPageToBreadCrumbs(SITE_PAGES.COLO[COLO_MENU.POWER], SITE_MODULES.COLO);
		if (site?.module !== 'COLO' || !permissions?.permissions) {
			this.getModulePages();
		}
		updateModule(SITE_MODULES.COLO);
		this.getModulePages();
		const mainContent = document.getElementById('main-content');
		if (mainContent) {
			mainContent.classList.add('no-padding');
		}
	}

	getData = () => {
		const cabinets = [
			{
				billcycle: '2022-01-15 10:02:12.000+0000',
				dueDate: '13.2',
				type: 'Pending',
				invoiceid: 1059916,
				customerid: 346361,
				invoice_number: 2491,
				amount: 31.0,
				amount_due: 21.0,
				status: 27.2,
				filename: '346361-01152022-Invoice_2491.pdf',
				published: true,
				alias: 'Atlanta rack 1',
				transactions: [
					{
						invoiceId: 1059916,
						customerId: 346361,
						invoiceNumber: 'ATL1234',
						outstandingBalance: 1800.0,
						invoiceTotal: 3160.0,
						uri: 'https://stg-secure.fusebill.com/v1/invoices/1059916',
						transactionId: 116879094,
						effectiveDate: '2022-12-05 14:54:42+00',
						description: 'Cash',
						transactionType: 'Payment',
						reference: null,
						amount: 200.0,
					},
				],
			},
			{
				billcycle: '2022-01-15 10:02:12.000+0000',
				dueDate: '17.2',
				type: 'Pending',
				invoiceid: 10599163,
				customerid: 3463613,
				invoice_number: 24912,
				amount: 38.4,
				amount_due: 26.6,
				status: 23.2,
				filename: '346361-01152022-Invoice_2491.pdf',
				published: true,
				alias: 'Best rack 1',
				transactions: [
					{
						invoiceId: 1059916,
						customerId: 346361,
						invoiceNumber: 'ATL14',
						outstandingBalance: 1800.0,
						invoiceTotal: 3160.0,
						uri: 'https://stg-secure.fusebill.com/v1/invoices/1059916',
						transactionId: 116879094,
						effectiveDate: '2022-12-05 14:54:42+00',
						description: 'Cash',
						transactionType: 'Payment',
						reference: null,
						amount: 200.0,
					},
				],
			},
		];

		try {
			const formattedInvoices = [];

			cabinets.forEach(invoice => {
				const transactions = invoice?.transactions;
				const formattedTransactions = [];
				transactions.forEach(transaction => {
					console.log(transaction);
					//const amount = transaction?.amount ? transaction?.amount : '';
					//const transactionType = 'due';
					formattedTransactions.push({
						one: { value: '62.203', size: 'sm' },
						two: { value: 'ATL', size: 'sm' },
						three: {
							value: '',
							size: 'sm',
							amount: false,
							type: '',
						},
					});
				});
				formattedInvoices.push({
					startDate: invoice?.startDate,
					id: invoice?.invoiceId,
					key: invoice?.invoice_number,
					values: [
						{ label: invoice?.invoice_number, size: 'sm' },
						{ label: invoice?.alias, size: 'sm' },
						{ label: invoice?.amount, size: 'sm' },
						{ label: invoice?.dueDate, size: 'sm' },
						{ label: invoice?.amount_due, size: 'sm' },
						{ label: invoice?.status, size: 'sm' },
					],
					expandedHeaders: [
						{ label: 'Capacity Avg', size: 'sm' },
						//{ label: '', size: 'lg' },
						{ label: 'Location', size: 'sm' },
					],
					expandedSize: 'lg',
					expandedValues: formattedTransactions,
					button1: { text: 'View', onClick: () => {} },
					button2: null,
				});
			});

			return formattedInvoices;
		} catch (e) {
			console.log(e);
		}
	};

	getModulePages = async () => {
		const {
			updatePermissions,
			auth_status: {
				user: { id: userId },
			},
			company_info: {
				customer: { id: orgId },
			},
		} = this.props;
		const response = await Permissions.getModulePermissions(5, userId, orgId);

		if (response && !response.data.error) {
			updatePermissions(response.data.pages);
		}
	};

	getHeaders = () => {
		return [
			{ label: 'Name', size: 'sm' },
			{ label: 'Alias', size: 'sm' },
			{ label: 'Avg kW', size: 'sm' },
			{ label: 'Max kW', size: 'sm' },
			{ label: 'Contracted kW', size: 'sm' },
			{ label: 'Provisioned kW', size: 'sm' },
		];
	};
	changeState = () => {
		this.setState({ show: 'list' });
	};

	render() {
		const {
			// breakpoint,
			// location,
			site,
			permissions: pages,
			company_info: {
				customer: { id },
			},
			navigate,
		} = this.props || {};
		const { show } = this.state;
		console.log(id);
		console.log('pages', pages);

		// const hasTicketStatusAccess = Permissions.checkComponentAccess(
		// 	pages,
		// 	'Overview',
		// 	'view-ticket-status',
		// );
		//const hasTicketStatusAccess = true;

		const module = site?.module;
		console.log(module);
		console.log(show);
		return (
			<div className='rack-detail-page'>
				<Example navigate={navigate} />
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		auth_status: state.auth_status,
		company_info: state.company_info,
		site: state.site_tracking,
		permissions: state.permissions,
	};
}

export default connect(mapStateToProps, {
	updateModule,
	updatePage,
	addPageToBreadCrumbs,
	updateUsers,
	updatePermissions,
	setHomeTour,
})(PowerPage);
